import React, { useEffect } from 'react'
import { 
  Canvas,
  group, 
  mesh, 
  boxBufferGeometry, 
  meshStandardMaterial 
} from '@react-three/fiber'

const basicExample = () => { 
  document.title = "Basic ThreeJs Example"
  return (
    <Canvas>
      <group position={[0,0.1,0.1]}>
        <ambientLight intensity={0.1} />
        <directionalLight color="white" position={[0, 0, 5]} />
        <mesh>
          <boxBufferGeometry attach="geometry" args={[1, 0.5, 0.29]} />
          <meshStandardMaterial attach="material" color='purple' />
        </mesh>
      </group>
    </Canvas>
  )
}

export default basicExample